<template>
  <!-- 补充个人资料扫描件 -->
  <div class="personal_data_proposal">
    <div class="personal_data_first">
      <div class="personal_data_name">补充个人资料扫描件</div>
      <div :class="'personal_data personal_data_' + dataObject.synergeticState">
        {{ judgmentStatus(dataObject.synergeticState) }}
      </div>
    </div>
    <div style="padding-left: 5px">
      <el-form label-width="100px" label-position="left">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名：" label-width="60px">
              <div>{{ dataObject.boxSynergeticEmployeeVo.trueName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别：" label-width="60px">
              <div>
                {{
                  dataObject.boxSynergeticEmployeeVo.sex === "1" ? "男" : "女"
                }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属部门：">
              <div>{{ dataObject.boxSynergeticEmployeeVo.orgName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="岗位：" label-width="60px">
              <div>{{ dataObject.boxSynergeticEmployeeVo.positionName }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="任务接收人：">
          <div>
            <span
              v-for="(item, index) in dataObject.boxEmplList"
              style="margin-right: 6px"
              :key="index"
              >{{ item.trueName }}</span
            >
            <el-button
              type="warning"
              size="mini"
              v-if="dataObject.synergeticState !== 'YWC'"
              @click="increaseRecipient"
              >添加接收人</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="任务截至时间：" label-width="110px">
          <div>{{ dataObject.jobOverDate }}</div>
        </el-form-item>
        <el-form-item label="任务选择：">
          <div>
            <span
              style="margin-right: 8px"
              v-if="dataObject.boxSynergeticEmployeeVo.selectCard === 'Y'"
              >身份证扫描件</span
            ><span
              style="margin-right: 8px"
              v-if="dataObject.boxSynergeticEmployeeVo.selectEdu === 'Y'"
              >学历/学位扫描件</span
            >
            <span
              style="margin-right: 8px"
              v-if="dataObject.boxSynergeticEmployeeVo.selectOcc === 'Y'"
              >职业证书扫描件</span
            >
          </div>
        </el-form-item>
        <el-form-item label="任务说明：">
          <div>
            {{ dataObject.jobDesc }}
          </div>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item
          label="身份证正面扫描件："
          label-width="140px"
          v-if="dataObject.boxSynergeticEmployeeVo.selectCard === 'Y'"
        >
          <JYOssUploadFiles
            :file-list="iDCardFileZM"
            :limit="1"
            :statusIsEdit="dataObject.synergeticState == 'YWC'"
            :accept="'.doc,.docx,.pdf,.xlsx,.xls,.png,.jpg,.jpeg'"
          />
        </el-form-item>

        <el-form-item
          label="身份证反面扫描件："
          label-width="140px"
          v-if="dataObject.boxSynergeticEmployeeVo.selectCard === 'Y'"
        >
          <JYOssUploadFiles
            :file-list="iDCardFileFM"
            :limit="1"
            :statusIsEdit="dataObject.synergeticState == 'YWC'"
            :accept="'.doc,.docx,.pdf,.xlsx,.xls,.png,.jpg,.jpeg'"
          />
        </el-form-item>

        <el-form-item
          label="学历/学位扫描件："
          label-width="130px"
          v-if="dataObject.boxSynergeticEmployeeVo.selectEdu === 'Y'"
        >
          <JYOssUploadFiles
            :file-list="educationFile"
            :statusIsEdit="dataObject.synergeticState == 'YWC'"
            :accept="'.doc,.docx,.pdf,.xlsx,.xls,.png,.jpg,.jpeg'"
          />
        </el-form-item>
        <el-form-item
          label="职业证书扫描件："
          label-width="130px"
          v-if="dataObject.boxSynergeticEmployeeVo.selectOcc === 'Y'"
        >
          <JYOssUploadFiles
            :file-list="certificateFile"
            :statusIsEdit="dataObject.synergeticState == 'YWC'"
            :accept="'.doc,.docx,.pdf,.xlsx,.xls,.png,.jpg,.jpeg'"
          />
        </el-form-item>
        <div style="text-align: center; margin-top: 20px">
          <el-button
            type="primary"
            @click="confirmCompletion"
            v-if="dataObject.synergeticState !== 'YWC'"
            >确认完成</el-button
          >
        </div>
      </el-form>
    </div>
    <!-- 添加接收人 -->
    <el-dialog
      title="添加接收人"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        ref="recipientForm"
        :model="recipientForm"
        :rules="recipientRules"
        label-position="left"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-form-item label="接收人：" prop="employeeId">
          <el-select
            v-model="recipientForm.employeeId"
            filterable
            clearable
            placeholder="请选择接收人"
            style="width: 100%"
          >
            <el-option
              v-for="item in personnelList"
              :key="item.employeeId"
              :label="item.trueName"
              :value="item.employeeId + ',' + item.trueName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div style="text-align: center; margin-top: 20px">
          <el-button type="primary" @click="submit('recipientForm')"
            >提交</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { addBoxEmpl, addFinish, retrievalBack } from '@/api/bidBox'
import BoxFileList from '@/components/uploadfiel/boxFileList'
import { fileUpload } from '@/api/publiccommon'
export default {
  name: 'PersonalData',
  components: {
    BoxFileList
  },
  computed: {

  },
  props: {
    dataObject: {
      type: Object,
      default: {},
      required: true
    },
    personnelList: {
      type: Array,
      default: {},
      required: true
    },
    btnauth: {
      type: Array,
      default: {},
      required: true
    },
  },
  data () {
    return {
      dialogVisible: false,
      recipientForm: {
        employeeId: ''
      },//接收人 表单提交
      recipientRules: {
        employeeId: [
          { required: true, message: '请选择接收人', trigger: 'change' }
        ]
      },
      iDCardFileZM: [],//身份证附件正面
      iDCardFileFM: [],//身份证附件反面
      educationFile: [],//学历附件
      certificateFile: [],//证书附件
    }
  },
  watch: {

  },
  created () {
    this.dataObject.boxSynergeticEmployeeVo.throwFileEntities.forEach(ele => {
      if (ele.businessType === 'SFZZM') {
        this.iDCardFileZM.push(ele)
      } else if (ele.businessType === 'SFZFM') {
        this.iDCardFileFM.push(ele)
      } else if (ele.businessType === 'XL') {
        this.educationFile.push(ele)
      } else if (ele.businessType === 'ZYZS') {
        this.certificateFile.push(ele)
      }
    })
  },
  mounted () {

  },
  methods: {
    // 打开 添加接收人 表单
    increaseRecipient () {
      this.dialogVisible = true
    },
    // 添加接收人 提交
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = this.recipientForm.employeeId.split(',')
          let par = {
            boxId: this.dataObject.boxId,
            employeeId: arr[0],
            trueName: arr[1]
          }
          addBoxEmpl(par).then(res => {
            if (res.status === 200) {
              this.$message.success('接收人添加成功')
              this.recipientForm = {
                employeeId: ''
              }//接收人 表单提交
              this.$refs[formName].resetFields()
              this.$emit('renewList')
              this.dialogVisible = false
            }
          })
        } else {
          return false
        }
      })
    },

    // 关闭接收人 表单
    handleClose () {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.dialogVisible = false
          this.$refs['recipientForm'].resetFields()
        })
        .catch(_ => { })
    },
    // 确认完成
    confirmCompletion () {
      if (this.dataObject.boxSynergeticEmployeeVo.selectCard === 'Y' && this.iDCardFileZM.length === 0) {
        return this.$message.warning('请上传身份证正面！')
      } else {
        this.iDCardFileZM.forEach(item => {
          item.businessType = 'SFZZM'
        })
      }
      if (this.dataObject.boxSynergeticEmployeeVo.selectCard === 'Y' && this.iDCardFileFM.length === 0) {
        return this.$message.warning('请上传身份证反面！')
      } else {
        this.iDCardFileFM.forEach(item => {
          item.businessType = 'SFZFM'
        })
      }
      if (this.dataObject.boxSynergeticEmployeeVo.selectEdu === 'Y' && this.educationFile.length === 0) {
        return this.$message.warning('请上传学历/学位扫描件！')
      } else {
        this.educationFile.forEach(item => {
          item.businessType = 'XL'
        })
      }
      if (this.dataObject.boxSynergeticEmployeeVo.selectOcc === 'Y' && this.certificateFile.length === 0) {
        return this.$message.warning('请上传职业证书扫描件！')
      } else {
        this.certificateFile.forEach(item => {
          item.businessType = 'ZYZS'
        })
      }
      this.$confirm('此操作将确认完成, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let arr = []
        arr = this.iDCardFileZM.concat(this.iDCardFileFM)
        arr = arr.concat(this.educationFile)
        arr = arr.concat(this.certificateFile)
        let par = {
          boxId: this.dataObject.boxId,
          businessId: this.dataObject.boxId,
          modleType: this.dataObject.modleType,
          modleId: this.dataObject.modleId,
          throwFileEntities: arr
        }
        addFinish(par).then(res => {
          if (res.status === 200) {
            this.$message.success('已确认完成')
            this.backfillRetrieval()
            this.$emit('renewList')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消确认完成'
        })
      })
    },
    // 判断状态
    judgmentStatus (type) {
      if (type === 'DWC') {
        return '待完成'
      } else if (type === 'YWC') {
        return '已完成'
      } else if (type === 'YZF') {
        return '已作废'
      }
    },
    // 超出最大上传限制
    handleExceed () {

    },
    // 人员检索 回填 点击确认完成 调用
    backfillRetrieval () {
      let dataSFZ = null
      let dataXL = null
      let dataZYZS = null

      let arr = this.certificateFile
      arr.forEach(ele => {
        ele.businessType = 14
      })
      // 身份证
      if (this.dataObject.boxSynergeticEmployeeVo.selectCard === 'Y') {
        dataSFZ = {
          idcardBeforeAddress: this.iDCardFileZM[0].filePath,
          idcardBackAddress: this.iDCardFileFM[0].filePath,
        }
      }
      // 学历
      if (this.dataObject.boxSynergeticEmployeeVo.selectEdu === 'Y') {
        dataXL = this.educationFile
      }
      // 职业证书
      if (this.dataObject.boxSynergeticEmployeeVo.selectOcc === 'Y') {
        let arr = this.certificateFile
        arr.forEach(ele => {
          ele.businessType = 14
        })
        dataZYZS = arr
      }
      let par = {
        employeeId: this.dataObject.boxSynergeticEmployeeVo.employeeId,
        emplCertificateFilePos: dataZYZS,
        employeeEducationFilePos: dataXL,
        retrievalIdCardBackPo: dataSFZ
      }
      retrievalBack(par).then(res => { })
    }
  },
}
</script>

<style lang="scss" scoped>
.personal_data_proposal {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #fa8601;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .personal_data_first {
    display: flex;
    justify-content: space-between;
    .personal_data_name {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 700;
    }
    .personal_data {
      height: 32px;
      padding: 0 10px;
      line-height: 30px;
      font-size: 12px;
      border-style: solid;
      border-radius: 4px;
      box-sizing: border-box;
      white-space: nowrap;
    }
    .personal_data_YWC {
      color: #026235;
      border: 1px solid #00f985;
      background: #b9e9d3;
    }
    .personal_data_DWC {
      color: #a10303;
      border: 1px solid #a10303;
      background: #f0a7a7;
    }
    .personal_data_YCH {
      color: #909399;
      border: 1px solid #909399;
      background: #f4f4f5;
    }
  }
}
::v-deep .el-form-item {
  margin-bottom: 0 !important;
}
::v-deep .text-ellipsis {
  max-width: 9vw;
}
</style>
